import {FetchService} from "dc-services/fetch.service";
import {priceToFloat} from "./helper";
import {replaceItemno} from "./replaceItemno";

export function depositCosts() {
    getDepositCostOnArticleCard();
    getDepositCostsInBasket();
    getDepositCostsInCheckout();
    getDepositCostsForHistoryListItem();
    getDepositCostsForItemboxList();
    editOrderDetails();
}

function getDepositCostOnArticleCard() {
    const btItemPrice = document.getElementById("btItemPrice");
    const itemNo = document.getElementById("beturboItemNo");
    const depositCostsElement = document.getElementById("depositCosts");

    if(btItemPrice && itemNo && depositCostsElement) {
        let data = {
            countryCode : "D",
            itemNo : itemNo.value,
        };
        let sendData = JSON.stringify(data);

        calculateForItemNo(sendData).then((response) => {

            const depositCost = response.depositCost;
            if(depositCost) {
                const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: 'EUR'
                }).format(depositCost);
                depositCostsElement.innerHTML = GLOBALS.tc.extraDepositCosts + " " + formatPrice;
            }
        });
    }
}

export async function calculateForItemNo(sendData) {
    const response = await FetchService.post('/em/depositCost/calculateForItemNo/', sendData);
    if(response.success) {
        let data = response.data;
        return data;
    }
}

export async function calculateForItemBatch(sendData) {
    const response = await FetchService.post('/em/depositCost/calculateItemBatch/', sendData);
    if(response.success) {
        let data = response.data;
        return data;
    }
}

function getDepositCostsInBasket() {
    calculateBasketDeposits();

    document.addEventListener("updateBasketViews", function () {
        calculateBasketDeposits();
        replaceItemno();
    })
}

function calculateBasketDeposits() {

    let itemData = [];
    const basketElements = document.querySelectorAll(".itemBasketBox[data-id]");
    for(const basketElement of basketElements) {
        const itemNo = basketElement.dataset.itemno;
        const itemprice = basketElement.dataset.itemprice;

        const item = {
            "itemNo" : itemNo,
        };

        itemData.push(item);

        let data = {
            countryCode : "D",
            itemNo : itemNo,
        };
        let sendData = JSON.stringify(data);

        calculateForItemNo(sendData).then((response) => {

            const depositCost = response.depositCost;
            let totalCost = response.totalCost;


            if(Number.isFinite(depositCost) && Number.isFinite(totalCost)) {
                const numberInput = basketElement.querySelector("input[type='number']");
                if(numberInput) {
                    const qty = numberInput.value;
                    totalCost = (parseFloat(itemprice) + parseFloat(depositCost)) * qty;
                }

                const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: document.body.dataset.defaultCurrency
                }).format(depositCost);
                const depositCostsElement = basketElement.querySelector(".basketDepositCosts");
                if(depositCostsElement && depositCost) {
                    depositCostsElement.innerHTML = "+ " + formatPrice + " " + GLOBALS.tc.deposit_costs;
                }

                const formatTotalPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: document.body.dataset.defaultCurrency
                }).format(totalCost);

                const totalCostsElement = basketElement.querySelector(".itemBasketBox__sumPrice");
                if(totalCostsElement) {
                    totalCostsElement.classList.remove("loadSkeleton");
                    totalCostsElement.innerHTML = parseFloat(itemprice) === 0 ? GLOBALS.tc.request_price : formatTotalPrice;
                }
            }
        });
    }

    getTotalCosts(itemData);
}

async function getDepositCostsInCheckout() {

    let totalDepositCosts = 0;

    const orderItems = document.querySelectorAll(".orderItem[data-id]");
    const promises = [];

    let vatPercent = 0;
    let vatCostsSum = 0;

    for (const orderItem of orderItems) {
        const price = Number(orderItem.dataset.price);
        const itemNo = orderItem.dataset.itemno;

        const data = {
            countryCode: "D",
            itemNo: itemNo,
        };

        const sendData = JSON.stringify(data);

        promises.push(
            calculateForItemNo(sendData).then((response) => {

                const depositCost = Number(response.depositCost);
                if(vatPercent === 0) {
                    vatPercent = Number(response.vatPercent);
                }


                const numberInput = orderItem.querySelector(".orderItem__quantity");
                const qty = numberInput ? Number(numberInput.innerHTML) : 1;
                let totalCost = (parseFloat(price) + parseFloat(depositCost)) * qty;
                totalDepositCosts += depositCost * qty;
                vatCostsSum += parseFloat(response.vatCost) * qty;

                if(depositCost) {
                    const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                        style: 'currency',
                        currency: document.body.dataset.defaultCurrency
                    }).format(depositCost);

                    const depositCostsElement = orderItem.querySelector(".orderDepositCosts");
                    if (depositCostsElement) {
                        depositCostsElement.innerHTML =
                            "+ " + formatPrice + " " + GLOBALS.tc.deposit_costs;
                    }
                }

                const formatTotalPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: document.body.dataset.defaultCurrency
                }).format(totalCost);

                const totalCostsElement = orderItem.querySelector(".orderItem__sumPrice");
                if(totalCostsElement) {
                    totalCostsElement.classList.remove("loadSkeleton");
                    totalCostsElement.innerHTML = price === 0 ? GLOBALS.tc.request_price : formatTotalPrice;
                }

                const hiddenInput = orderItem.querySelector("input[name*='deposit']");

                if(hiddenInput) {
                    hiddenInput.value = formatTotalPrice;
                }
            })
        );
    }

    // ⏳ WARTEN bis ALLE calculateForItemNo fertig sind
    await Promise.all(promises);

    // ✅ JETZT ist totalDepositCosts final
    updateSummary(totalDepositCosts, vatCostsSum, vatPercent);
}

function updateSummary(totalDepositCosts, vatCostsSum, vatPercent) {

    const totalDepositCostsFormatted = new Intl.NumberFormat(document.body.dataset.localeCode, {
        style: 'currency',
        currency: document.body.dataset.defaultCurrency
    }).format(totalDepositCosts);

    const formUserOrder = document.getElementById("form_user_order");
    if (!formUserOrder) return;

    const amountLines = formUserOrder.querySelector(".orderboxSummary__main .amountLines");
    if (!amountLines) return;

    if(totalDepositCosts > 0) {
        amountLines.innerHTML += `
        <div class="amountLine">
            <div class="amountLine__label">${GLOBALS.tc.deposit_costs}</div>
            <div class="amountLine__value">+${totalDepositCostsFormatted}</div>
        </div>
    `;
    }

    let total = 0.0;
    const values = amountLines.querySelectorAll(".amountLine__value");
    for (const priceValue of values) {
        total += priceToFloat(priceValue.innerHTML);
    }

    const totalVatCosts = new Intl.NumberFormat(document.body.dataset.localeCode, {
        style: 'currency',
        currency: document.body.dataset.defaultCurrency
    }).format(vatCostsSum);

    const totalCost = new Intl.NumberFormat(document.body.dataset.localeCode, {
        style: 'currency',
        currency: document.body.dataset.defaultCurrency
    }).format(total);

    const totalSumElement = document.querySelector("#basketTotal .amountLine__value");
    if(totalSumElement) {
        totalSumElement.innerHTML = total === 0 ? GLOBALS.tc.request_price : totalCost;
        totalSumElement.classList.remove("loadSkeleton");
    }

    const vatLabel = document.querySelector("#basketTax .amountLine__label");
    const vatValue = document.querySelector("#basketTax .amountLine__value");
    if(vatLabel && vatValue) {
        vatLabel.innerHTML = GLOBALS.tc.plus_vat + " (" + vatPercent + "%)";
        vatValue.innerHTML = totalVatCosts;
        vatLabel.classList.remove("loadSkeleton");
        vatValue.classList.remove("loadSkeleton");
    }

    const inputDeposit = formUserOrder.querySelector("input[name='ad_total_deposit_costs']");
    if(inputDeposit) {
        inputDeposit.value = totalDepositCostsFormatted;
    }

    const inputTotal = formUserOrder.querySelector("input[name='ad_total_costs_without_vat']");
    if(inputDeposit) {
        inputTotal.value = totalCost;
    }

    const inputVat = formUserOrder.querySelector("input[name='ad_total_vat_costs']");
    if(inputVat) {
        inputVat.value = totalVatCosts;
    }
}


function getTotalCosts(itemData) {
    const data = {
        "countryCode" : "D",
        "itemData" : itemData
    };
    let sendData = JSON.stringify(data);

    calculateForItemBatch(sendData).then((response) => {

        let totalCost = 0;
        const items = response.itemData;

        let vatCost = 0;
        let depositCost = 0;

        let vatPercent = 0;
        let vatTotalSum = 0;

        for(const item of items) {

            const itemNo = item.itemNo;
            let qty = 1;
            const itemBasketBox = document.querySelector(".itemBasketBox[data-itemno='" + itemNo +"']");
            if(itemBasketBox) {
                const input = itemBasketBox.querySelector("input[type=\"number\"]");
                if(input) {
                    qty = input.value;
                }
            }

            if(vatPercent === 0) {
                vatPercent = item.vatPercent;
            }

            totalCost += parseFloat(item.totalCost) * qty;
            depositCost += parseFloat(item.depositCost) * qty;
            vatTotalSum += parseFloat(item.vatCost) * qty;
        }

        const depositCostString = new Intl.NumberFormat(document.body.dataset.localeCode, {
            style: 'currency',
            currency: document.body.dataset.defaultCurrency
        }).format(depositCost);



        const userBasket = document.getElementById("userBasket");
        if(userBasket) {
            const amountLines = userBasket.querySelector(".orderboxSummary__main .amountLines");
            if(amountLines && depositCost > 0) {
                amountLines.innerHTML += "<div class=\"amountLine\"><div class='amountLine__label'>" + GLOBALS.tc.deposit_costs + "</div><div class='amountLine__value'>+" + depositCostString + "</div></div>";
            }

            let total = 0.0;
            const values = amountLines.querySelectorAll(".amountLine__value");
            for(const priceValue of values) {
                total += priceToFloat(priceValue.innerHTML);
            }

            vatCost = new Intl.NumberFormat(document.body.dataset.localeCode, {
                style: 'currency',
                currency: document.body.dataset.defaultCurrency
            }).format(vatTotalSum);

            totalCost = new Intl.NumberFormat(document.body.dataset.localeCode, {
                style: 'currency',
                currency: document.body.dataset.defaultCurrency
            }).format(total);

            const totalSumElement = document.querySelector("#basketTotal .amountLine__value");
            if(totalSumElement) {
                totalSumElement.innerHTML = total === 0 ? GLOBALS.tc.request_price : totalCost;
                totalSumElement.classList.remove("loadSkeleton");
            }

            const vatLabel = document.querySelector("#basketTax .amountLine__label");
            const vatValue = document.querySelector("#basketTax .amountLine__value");
            if(vatLabel && vatValue) {
                vatLabel.innerHTML = GLOBALS.tc.plus_vat + " (" + vatPercent + "%)";
                vatValue.innerHTML = vatCost;
                vatLabel.classList.remove("loadSkeleton");
                vatValue.classList.remove("loadSkeleton");
            }
        }
    });
}

function editOrderDetails() {
    const el = document.querySelector(".modal--webshop-orders-archive-card");
    if(el) {
        const itemData = [];
        const orderItems = el.querySelectorAll(".orderItem[data-itemno]");
        for (const orderItem of orderItems) {
            const itemNo = orderItem.dataset.itemno;
            const item = {
                "itemNo": itemNo,
            };
            itemData.push(item);
        }

        const data = {
            "countryCode": "D",
            "itemData": itemData
        };
        let sendData = JSON.stringify(data);

        calculateForItemBatch(sendData).then((response) => {
            const items = response.itemData;
            let totalCost = 0;
            let depositCost = 0;

            for (const item of items) {

                const itemNo = item.itemNo;

                let itemCostsWithoutVat = 0;
                let qty = 1;
                const orderItem = el.querySelector(".orderItem[data-itemno='" + itemNo + "']");
                if (orderItem) {
                    const qtyColumn = orderItem.querySelector(".orderItem__quantity");
                    if (qtyColumn) {
                        qty = qtyColumn.innerText;
                    }

                    const priceColumn = orderItem.querySelector(".orderItemDepositCosts");
                    if (priceColumn && parseFloat(item.depositCost)) {
                        priceColumn.innerHTML = "+ " + new Intl.NumberFormat(document.body.dataset.localeCode, {
                            style: 'currency',
                            currency: document.body.dataset.defaultCurrency
                        }).format(parseFloat(item.depositCost)) + " " + GLOBALS.tc.deposit_costs;
                    }

                    const basePrice = orderItem.querySelector(".orderItem__price .basePrice");
                    const baseSumPrice = orderItem.querySelector(".orderItem__sumPrice");
                    if (basePrice && baseSumPrice) {
                        let price = 0;
                        if(basePrice.innerHTML) {
                            price = priceToFloat(basePrice.innerHTML);
                        }

                        if (price === 0) {
                            basePrice.textContent = GLOBALS.tc.request_price;
                            baseSumPrice.innerHTML = GLOBALS.tc.request_price;
                            baseSumPrice.classList.remove("loadSkeleton");
                        } else {
                            itemCostsWithoutVat = (price + parseFloat(item.depositCost)) * qty;
                            totalCost += itemCostsWithoutVat;
                            baseSumPrice.innerHTML = new Intl.NumberFormat(document.body.dataset.localeCode, {
                                style: 'currency',
                                currency: document.body.dataset.defaultCurrency
                            }).format(itemCostsWithoutVat);
                            baseSumPrice.classList.remove("loadSkeleton");
                        }
                    }
                }
                depositCost += parseFloat(item.depositCost) * qty;
            }

            const depositSumElement = el.querySelector("#depositCostsSum .amountLine__value");
            const depositSumLabel = el.querySelector("#depositCostsSum .amountLine__label");
            if (depositSumElement && depositSumLabel && depositCost > 0) {
                depositSumLabel.innerHTML = GLOBALS.tc.deposit_costs;
                depositSumElement.innerHTML = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: document.body.dataset.defaultCurrency
                }).format(depositCost);
            }

            const sumAmountLine = el.querySelector("#sumAmountLine .amountLine__value");
            if (sumAmountLine) {

                sumAmountLine.innerHTML = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: document.body.dataset.defaultCurrency
                }).format(totalCost);
            }
        });
    }
}

async function getDepositCostsForHistoryListItem() {
    const listItems = document.querySelectorAll(".orderHistoryListItem:not(.orderHistoryListItem--header)");
    for(const listItem of listItems) {

        const response = await FetchService.get('/em/depositCost/getAdditionalDataForSalesHeader/' + listItem.dataset.orderno);
        if(response.success) {
            const sum = response.data.total_costs_without_vat;
            const sumSpan = listItem.querySelector(".orderHistoryListItemSumPrice");
            if(sumSpan) {
                if(sum) {
                    sumSpan.innerHTML = sum;

                }
                sumSpan.classList.remove("loadSkeleton");
            }

        }
    }
}

async function getDepositCostsForItemboxList() {
    const listItems = document.querySelectorAll(".itemboxList.itemboxList--5 .itembox__main");
    for(const listItem of listItems) {

        let data = {
            countryCode : "D",
            itemNo : listItem.dataset.itemno,
        };
        let sendData = JSON.stringify(data);

        calculateForItemNo(sendData).then((response) => {

            const depositCost = response.depositCost;
            if(depositCost) {
                const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: 'EUR'
                }).format(depositCost);
                const depositCostsElement = listItem.querySelector(".itemDepositCost");
                if(depositCostsElement) {
                    depositCostsElement.innerHTML = GLOBALS.tc.extraDepositCosts + " " + formatPrice;
                }
            }
        });
    }
}